import PageHeader from "@/components/site/PageHeader";
import { Volunteer } from "@/components/site/Forms";
import { CTABand } from "@/components/site/AboutSections";
import { usePageMeta } from "@/lib/usePageMeta";

export default function ServePage() {
  usePageMeta(
    "Volunteer & Serve",
    "Serve with RE//FORM PLACE CHI — join GO Teams, worship, hospitality, media, kids ministry, and more. Find your place on the team.",
  );
  return (
    <div data-testid="serve-page">
      <PageHeader
        crumb="Volunteer"
        eyebrow="Volunteer"
        title="Find Your Place"
        accent="On The Team"
        intro="Every gathering and every outreach day is powered by volunteers. Tell us where you'd love to serve."
        image="/outreach/volunteers-day.webp"
        imagePosition="center 35%"
      />
      <Volunteer />
      <CTABand
        eyebrow="On The Streets"
        title="See GO Teams In Action"
        text="Explore the outreach photo gallery and our 2025 impact numbers."
        primary={{ to: "/outreach", label: "Community Outreach" }}
        secondary={{ to: "/ministries", label: "Explore Ministries" }}
      />
    </div>
  );
}
